export default __webpack_public_path__ + "static/media/cute-christmas-tree.d572b12d.jpg";